export class Comment {

    public author: string;

    public authorProfileImageUrl: string;

    public authorChannelId: string;

    public textDisplay: string;

    public likeCount: number;

    public publishedAt: string;

    public replyCount: number;

    public replies: Comment[];
    
}


// WEBPACK FOOTER //
// ./src/app/comment.ts